module.exports = __webpack_public_path__ + "img/164.6f0aee2a.jpg";